import * as allExports from "@react-aria/separator";
const { useSeparator } = allExports;
export { useSeparator };
//# sourceMappingURL=main.entry.mjs.mjs.map